/* What the login and signup pages quote. Edit the text here.
 * photo: file in client/public/auth/people/   logo: file in client/public/auth/logos/
 * (logo.text: word set beside a mark-only logo; logo: height in px; aspect: width / height of the file, so it is not squashed) */
export const QUOTES = [
  {
    quote: 'Every trace is evaluated now, at about 60% less than it cost us to judge a sample. Silent failures arrive grouped by cause, so one fix closes the whole set.',
    name: 'Mrudul Chauhan',
    role: 'Head of Product & Growth, ORBT',
    photo: '/auth/people/mrudul-chauhan.jpg',
    logo: { src: '/auth/logos/orbt-grey.png', h: 20, aspect: 1.009, label: 'Orbt', text: 'ORBT' },
  },
  {
    quote: 'Judging every trace with a frontier model cost us far too much, so we sampled. Triage checks and Trodo’s own models cut the cost of an evaluation by about 80%, and now every trace is covered.',
    name: 'Keshav Pandya',
    role: 'Chief Technical Officer, Zeebu',
    photo: '/auth/people/keshav-pandya.jpg',
    logo: { src: '/auth/logos/zeebu.svg', h: 19, aspect: 4.506, label: 'Zeebu' },
  },
  {
    quote: 'Trodo is not just a place to watch traces. It digs into the data with you, opens the issues, and keeps alerts, issues and checks linked, so the whole thing evolves as your product does.',
    name: 'Suchit Puri',
    role: 'Director of AI FDEs, Google',
    photo: '/auth/people/suchit-puri.jpg',
    logo: { src: '/auth/logos/google.png', h: 24, aspect: 2.917, label: 'Google' },
  },
];
